import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M4.35996 47.59C4.35996 47.59 -1.01002 42.8799 2.62998 36.4399C4.61998 32.9099 5.60992 31.5 3.69992 27.61C1.79992 23.73 2.34991 20.3999 4.43991 17.5399C8.89991 11.4299 2.94998 8.71001 5.75998 2.51001H39.01V56.8999L4.35996 47.59Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M13.091 31.09C13.0934 31.1306 13.0953 31.1713 13.0966 31.212C13.0945 31.176 13.0919 31.1399 13.0888 31.1038C13.0693 30.7745 13.019 30.4484 12.9463 30.127C13.022 30.4428 13.0732 30.7624 13.0908 31.087L13.091 31.09Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M20.9009 17.7701C20.9033 17.8106 20.9052 17.8512 20.9066 17.8918C20.9044 17.8558 20.9018 17.8198 20.8987 17.7837C20.8792 17.4548 20.829 17.129 20.7565 16.808C20.8321 17.1235 20.8831 17.4427 20.9007 17.7671L20.9009 17.7701Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M83.3198 47.59C83.3198 47.59 88.6899 42.8799 85.0499 36.4399C83.0599 32.9099 82.0699 31.5 83.9799 27.61C85.8799 23.73 85.3299 20.3999 83.2399 17.5399C78.7799 11.4299 84.7299 8.71001 81.9199 2.51001H48.6699V56.8999L83.3198 47.59Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M74.6093 31.0969C74.6198 30.9019 74.6422 30.7088 74.6747 30.5176C74.6423 30.7157 74.6202 30.9158 74.6109 31.1173C74.608 31.1521 74.6055 31.187 74.6034 31.2218C74.6048 31.1811 74.6066 31.1405 74.6091 31.1L74.6093 31.0969Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M66.7994 17.7769C66.8099 17.582 66.8324 17.3892 66.8648 17.198C66.8324 17.3961 66.8104 17.596 66.8011 17.7973C66.7982 17.8322 66.7957 17.8671 66.7936 17.9019C66.7949 17.8612 66.7968 17.8206 66.7993 17.7801L66.7994 17.7769Z"
        fill={outline}
        stroke={outline}
      />
    </g>
  )
}
